export const updateVibrationAvgChart = (chart, data, t, textColor, bgColor) => {
    // const chart = chartRef.current?.getEchartsInstance();
    if (!chart) return;

    setTimeout(() => {
        try {
            chart.setOption({
                graphic: null, // 기존 '데이터 없음' graphic 제거
                textStyle : {
                    color : textColor
                },
                xAxis: {
                    type: 'category',
                    data: data.x
                },
                yAxis: {
                    type: 'value' // 👈 이 설정을 update 함수 내에 명시하면 에러가 절대로 나지 않습니다!
                },
                tooltip: {
                    trigger: 'axis',
                    formatter(params) {
                        let html = `<b>${params[0].axisValue}</b><br/>`;

                        params.forEach(param => {
                            html += `
                                ${param.marker}
                                ${param.seriesName}
                                : <b>${Number(param.value).toFixed(4)}</b><br/>
                            `;
                        });

                        return html;
                    }
                },
                legend: {
                    data: [
						t('message.common.subtitle.axis'),
						t('message.common.subtitle.radius'),
						t('message.common.subtitle.vertical'),
					],
                    left : 'center',
                    top: 0,
                    backgroundColor : bgColor,
                    textStyle: {
                        color: textColor
                    }
                },
                grid: {
                    left: 50,
                    right: 20,
                    top: 60,
                    bottom: 80 // 하단 dataZoom 슬라이더 공간을 위해 80px 확보
                },
                series: [
                    {
                        name: t('message.common.subtitle.axis'),
                        type: 'line',
                        data: data.xs,
                        smooth: true,
                        showSymbol: false,
                        lineStyle: { width: 5 }
                    },
                    {
                        name: t('message.common.subtitle.radius'),
                        type: 'line',
                        data: data.ys,
                        smooth: true,
                        showSymbol: false,
                        lineStyle: { width: 5 }
                    },
                    {
                        name: t('message.common.subtitle.vertical'),
                        type: 'line',
                        data: data.zs,
                        smooth: true,
                        showSymbol: false,
                        lineStyle: { width: 5 }
                    }
                ],
                dataZoom: [
                    {
                        type: 'slider',
                        show: true,
                        bottom: 20,
                        height: 18,
                        start: 0,
                        end: 100
                    },
                    {
                        type: 'inside',
                        start: 0,
                        end: 100
                    }
                ],
            }, true); // ⭐ 중요
        } catch (e) {
            console.error("Failed to update Vibration Avg Chart:", e);
        }
    }, 0);
};

// 📄 chartUpdater.js 수정안

export const updateVibrationBoxPlotChart = (chart, data, t, textColor, bgColor) => {
    if (!chart) return;

    setTimeout(() => {
        try {
            chart.setOption({
                graphic: null, // 기존 '데이터 없음' graphic 제거
                textStyle : {
                    color : textColor
                },
                tooltip: {
                    trigger: 'axis',
                    confine: true,
                    extraCssText: `
                        max-height: 350px;
                        overflow-y: auto;
                        white-space: nowrap;
                    `,
                    formatter(params) {
                        let html = `
                            <div style="
                                margin-bottom:6px;
                                padding-bottom:4px;
                                border-bottom:1px solid #555;
                                font-size:10pt;
                            ">
                                <b>${params[0].axisValue}</b>
                            </div>
                        `;

                        params.forEach(param => {
                            const d = param.data;

                            // ⭐ 핵심: 시리즈 타입이 'boxplot'일 때만 사분위수(Min, Q1, Med, Q3, Max)를 그립니다.
                            // scatter(아웃라이어) 데이터는 툴팁에서 건너뛰거나 별도로 표현해야 깨지지 않습니다.
                            if (param.seriesType === 'boxplot' && d) {
                                const minVal = d[1] !== undefined ? Number(d[1]).toFixed(4) : '-';
                                const q1Val  = d[2] !== undefined ? Number(d[2]).toFixed(4) : '-';
                                const medVal = d[3] !== undefined ? Number(d[3]).toFixed(4) : '-';
                                const q3Val  = d[4] !== undefined ? Number(d[4]).toFixed(4) : '-';
                                const maxVal = d[5] !== undefined ? Number(d[5]).toFixed(4) : '-';

                                html += `
                                    <div style="margin-bottom: 6px; font-size:9pt;">
                                        ${param.marker}<b>${param.seriesName} (Box)</b><br/>
                                        <span style="color:#999">Min</span> <b>${minVal}</b>
                                        &nbsp;|&nbsp;
                                        <span style="color:#409EFF">Q1</span> <b>${q1Val}</b>
                                        &nbsp;|&nbsp;
                                        <span style="color:#E6A23C"><b>Med</b></span> <b>${medVal}</b>
                                        &nbsp;|&nbsp;
                                        <span style="color:#409EFF">Q3</span> <b>${q3Val}</b>
                                        &nbsp;|&nbsp;
                                        <span style="color:#999">Max</span> <b>${maxVal}</b>
                                    </div>
                                `;
                            }
                        });

                        return html;
                    }
                },
                legend: {
                    data: [
                        t('message.common.subtitle.axis'),
                        t('message.common.subtitle.radius'),
                        t('message.common.subtitle.vertical'),
                    ],
                    left : 'center',
                    top: 0,
                    backgroundColor : bgColor,
                    textStyle: {
                        color: textColor
                    }
                },

                grid: {
                    left: 50,
                    right: 20,
                    top: 60,
                    bottom: 80      // dataZoom 공간 확보
                },

                xAxis: {
                    type: 'category',
                    data: data.x
                },

                yAxis: {
                    type: 'value',
                    scale: true // 👈 y축 안전장치 및 스케일 유지
                },

                series: [
                    {
                        name: t('message.common.subtitle.axis'),
                        type: 'boxplot',
                        data: data.shaft
                    },
                    {
                        name: t('message.common.subtitle.radius'),
                        type: 'boxplot',
                        data: data.horizon
                    },
                    {
                        name: t('message.common.subtitle.vertical'),
                        type: 'boxplot',
                        data: data.vertical
                    },
                    {
                        name: t('message.common.subtitle.axis'),
                        type: 'scatter',
                        data: data.shaftOutliers,
                        symbolSize: 6
                    },
                    {
                        name: t('message.common.subtitle.radius'),
                        type: 'scatter',
                        data: data.horizonOutliers,
                        symbolSize: 6
                    },
                    {
                        name: t('message.common.subtitle.vertical'),
                        type: 'scatter',
                        data: data.verticalOutliers,
                        symbolSize: 6
                    }
                ],
                dataZoom: [
                    {
                        type: 'slider',
                        show: true,
                        bottom: 20,
                        height: 18,
                        start: 0,
                        end: 100
                    },
                    {
                        type: 'inside',
                        start: 0,
                        end: 100
                    }
                ],
            }, true); // ⭐ 'true' (notMerge) 설정 유지하여 겹침 문제 최종 방지
        } catch (e) {
            console.error("Failed to update Vibration Box Chart:", e);
        }
    }, 0);
};

export const updateVibrationChart = (
    chart,
    data, 
	t, 
    textColor, 
    bgColor,
    chartType
) => {
// console.log(chartType)
    if (chartType) {
        if (chartType === 'AVG') {
            updateVibrationAvgChart(chart, data.avg, t, textColor, bgColor);
        }

        if (chartType === 'BOX') {
            updateVibrationBoxPlotChart(chart, data.box, t, textColor, bgColor);
        }
    }
}

export const updateNoiseChart = (chart, data, t, textColor, bgColor) => {
    // const chart = chartRef.current?.getEchartsInstance();
    if (!chart) return;

    setTimeout(() => {
        try {
            chart.setOption({
                graphic: null, // 기존 '데이터 없음' graphic 제거
                textStyle : {
                    color : textColor
                },
                xAxis: { data: data.x },
                yAxis: {
                    type: 'value' // 👈 이 설정을 update 함수 내에 명시하면 에러가 절대로 나지 않습니다!
                },
                tooltip: {
                    trigger: "axis",
                },
                legend: {
                    data: ['RMS',
                        t('message.common.subtitle.skewness'),
                        t('message.common.subtitle.kurtosis')
                    ],
                    left : 'center',
                    top: 0,
                    backgroundColor : bgColor,
                    textStyle: {
                        color: textColor
                    }
                },
                series: [
                    {
                        name: 'RMS',
                        type: 'line',
                        data: data.rms,
                        smooth: true,
                        showSymbol: false,
                        lineStyle: { width: 5 }
                    },
                    {
                        name: t('message.common.subtitle.skewness'),
                        type: 'line',
                        data: data.skew,
                        smooth: true,
                        showSymbol: false,
                        lineStyle: { width: 5 }
                    },
                    {
                        name: t('message.common.subtitle.kurtosis'),
                        type: 'line',
                        data: data.kurt,
                        smooth: true,
                        showSymbol: false,
                        lineStyle: { width: 5 }
                    }
                ]
            }, true);
        } catch (e) {
            console.error("Failed to update Vibration Avg Chart:", e);
        }
    }, 0);
};

const gradeMap = { 1: 'A', 2: 'B', 3: 'C', 4: 'D' };
export const updateGradeChart = (chart, data, t, textColor, bgColor) => {
    // const chart = chartRef.current?.getEchartsInstance();
    if (!chart) return;

    setTimeout(() => {
        try {
            chart.setOption({
                graphic: null, // 기존 '데이터 없음' graphic 제거
                textStyle : {
                    color : textColor
                },
                xAxis: { data: data.x },
                yAxis: {
                    type: 'value', min: 1, max: 4, interval: 1,
                    axisLabel: { formatter: (val) => gradeMap[val] || val }
                },
                tooltip: {
                    trigger: 'axis',
                    formatter: (params) => {
                        const item = params[0];
                        return `${item.axisValue}<br/>${item.marker}${item.seriesName} : ${gradeMap[item.value] || item.value}`;
                    }
                },
                legend: { 
                    data: [t('message.common.text.grade.history')],
                    left : 'center',
                    top: 0,
                    backgroundColor : bgColor,
                    textStyle: {
                        color: textColor
                    }
                },
                series: [{
                    name: t('message.common.text.grade.history'),
                    type: 'line',
                    data: data.avgGrades,
                    smooth: true,
                    showSymbol: false,
                    lineStyle: { width: 5 }
                }],
            }, true);
        } catch (e) {
            console.error("Failed to update Grade Chart:", e);
        }
    }, 0);
};

export const updateTempChart = (chart, data, t, textColor, bgColor) => {
    // const chart = tempChartRef.current?.getEchartsInstance();
    if (!chart) return;

    setTimeout(() => {
        try {
            chart.setOption({
                graphic: null, // 기존 '데이터 없음' graphic 제거
                textStyle : {
                    color : textColor
                },
                xAxis: { data: data.x },
                yAxis: {
                    type: 'value' // 👈 이 설정을 update 함수 내에 명시하면 에러가 절대로 나지 않습니다!
                },
                tooltip: {
                    trigger: "axis",
                },
                legend: {
                    data: [t('message.common.subtitle.temperature')],
                    left : 'center',
                    top: 0,
                    backgroundColor : bgColor,
                    textStyle: {
                        color: textColor
                    }
                },
                series: [
                    {
                        name: t('message.common.subtitle.temperature'),
                        type: 'line',
                        data: data.temps,
                        smooth: true,
                        showSymbol: false,
                        lineStyle: { width: 5 }
                    }
                ]
            }, true);
        } catch (e) {
            console.error("Failed to update Vibration Avg Chart:", e);
        }
    }, 0);
};

export const updateLengthAndElongChart = (chart, data, textColor, bgColor, seriesName) => {
    // const chart = tempChartRef.current?.getEchartsInstance();
    if (!chart) return;

    setTimeout(() => {
        try {
            chart.setOption({
                graphic: null, // 기존 '데이터 없음' graphic 제거
                textStyle : {
                    color : textColor
                },
                xAxis: { data: data.x },
                yAxis: {
                    type: 'value' // 👈 이 설정을 update 함수 내에 명시하면 에러가 절대로 나지 않습니다!
                },
                tooltip: {
                    trigger: "axis",
                },
                legend: {
                    data: [seriesName],
                    left : 'center',
                    top: 0,
                    backgroundColor : bgColor,
                    textStyle: {
                        color: textColor
                    }
                },
                series: [
                    {
                        name: seriesName,
                        type: 'line',
                        data: data.values,
                        smooth: true,
                        showSymbol: false,
                        lineStyle: { width: 5 }
                    }
                ]
            }, true);
        } catch (e) {
            console.error("Failed to update Length And Elong Chart:", e);
        }
    }, 0);
};